import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AtividadeParcela } from 'src/app/core/models/atividade/atividade-parcela';

import { environment } from 'src/environments/environment';
 
@Injectable({
  providedIn: 'root'
})
export class AtividadeParcelaService {

  private environmentUrl: string = '';

  constructor(
    private httpClient: HttpClient
  ) {
    this.environmentUrl = environment.ApiAtv;
  }

  listarParcelas(idAtividade: number): Observable<AtividadeParcela[]> {
    const url = this.environmentUrl + 'v1/Atividade/GetAtividadesParcelas/' + idAtividade;
    return this.httpClient.get<AtividadeParcela[]>(url);
  }
}

